<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <div class="flex mb-1">
        <label for="">{{$t('vendors') | capitalize}}</label>
      </div>
      <div class="flex mb-4">
        <v-select
          v-model="filters.vendors"
          :options="vendors"
          class="w-full"
          :reduce="(vendor) => vendor.id"
          label="name"
          multiple
        />
      </div>
      <div class="flex mb-4">
        <input-date :label="$t('start_date') | capitalize"  v-model="filters.startDate"/>
      </div>
      <div class="flex mb-4">
        <input-date :label="$t('end_date') | capitalize" v-model="filters.endDate"/>
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import InputDate from '@/components/custom/InputDate'
import vendor from '@/http/requests/vendor'
import moment from 'moment'
export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.vendors
    },
  },
  data: () => ({
    vendors: [],
    clients: [],
    filters: {
      vendors: [],
      startDate: '',
      endDate: '',
    },
    defaultFilters: {
      vendors: [],
      startDate: '',
      endDate: '',
    },
    loading: {
      vendors: false,
    },
  }),
  methods: {
    clear() {
      this.filters = Object.assign({}, this.defaultFilters)
    },
    close() {
     this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.filters = { ...this.value }
    },
     validateDate(){
      if(this.filters.startDate.length > 1 && this.filters.startDate.length < 10 ){
        this.filters.startDate = ''
         this.$vs.notify({
            color: 'danger',
            title: this.$i18n.messages[this.$i18n.locale].start_date,
            text: this.$i18n.messages[this.$i18n.locale].invalid_date
          });
          return false;
      }
      if(this.filters.endDate.length > 1 && this.filters.endDate.length < 10 ){
        this.filters.endDate = ''
         this.$vs.notify({
            color: 'danger',
            title: this.$i18n.messages[this.$i18n.locale].end_date,
            text: this.$i18n.messages[this.$i18n.locale].invalid_date
          });
          return false;
      }
      return true;
    },
    setFilter() {
      if(!this.validateDate()){
        return
      }
      this.$emit('input',this.filters)
      this.$emit('search')
      this.close()
    },
    getVendors() {
      this.loading.vendors = true
      vendor
        .list()
        .then((res) => {
          this.vendors = res.data.vendors
          this.loading.vendors = false
        })
        .catch((err) => {
          this.loading.vendors = false
        })
    },
  },
  mixins: [loading],
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
  mounted(){
    this.getVendors()
  }
}
</script>

<style>
</style>
